import { render, staticRenderFns } from "./StoryCommentReply.vue?vue&type=template&id=dbdb8a72&"
import script from "./StoryCommentReply.vue?vue&type=script&lang=js&"
export * from "./StoryCommentReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports